import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TbsIconModule } from '@ngx-terabase/ui/icon';
export interface TreeNode {
  name: string;
  children?: TreeNode[];
  expanded?: boolean;
}

@Component({
  standalone: true,
  imports: [CommonModule, TbsIconModule],
  selector: 'app-file-tree-node',
  template: `
    <ul class="tree-list">
      <li *ngFor="let node of nodes" class="tree-node">
        <div
          class="node-row"
          (click)="toggle(node)"
          [class.clickable]="!!node.children"
        >
          <span class="icon">
            <ng-container *ngIf="node.children; else fileIcon">
              @if(node.expanded) {
              <tbs-icon icon="calcite:minus-square-16" size="small" color="black"></tbs-icon>
              } @else {
              <tbs-icon icon="calcite:plus-square-16" size="small" color="black"></tbs-icon>
              }
            </ng-container>
            <ng-template #fileIcon>
              <tbs-icon icon="calcite:file-16" size="small"></tbs-icon>
            </ng-template>
          </span>
          <span class="tb-body-secondary">{{ node.name }}</span>
        </div>
        <app-file-tree-node
          *ngIf="node.children && node.expanded"
          [nodes]="node.children"
        ></app-file-tree-node>
      </li>
    </ul>
  `,
  styles: [
    `
      .folder {
        color: black;
      }
      .tree-list {
        list-style: none;
        padding-left: 0.5rem;
        margin: 0;
      }

      .tree-list:first-of-type > ul:first-of-type > li::before {
        display: none;
      }

      .tree-node {
        position: relative;
        padding-left: 1.5rem;
      }

      .tree-node::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0.6rem;
        bottom: 0;
        width: 1px;
        background-color: #ccc;
      }

      .node-row {
        position: relative;
        display: flex;
        align-items: center;
        padding-left: 0.5rem;
        cursor: default;
        user-select: none;
      }

      .node-row.clickable {
        cursor: pointer;
      }

      .icon {
        width: 20px;
        text-align: center;
        margin-right: 4px;
      }
    `,
  ],
})
export class FileTreeNodeComponent {
  @Input() nodes: TreeNode[] = [];

  toggle(node: TreeNode): void {
    if (node.children) {
      node.expanded = !node.expanded;
    }
  }
}
